import { ChangeDetectionStrategy, Component, ElementRef, Inject, Input } from '@angular/core';
import { SvgIconRegistry } from './registry';
import { SVG_CONFIG, SVG_ICONS_CONFIG } from './types';

@Component({
  selector: 'elio-svg-icon',
  template: '',
  host: {
    role: 'img',
    'aria-hidden': 'true',
  },
  styles: [
    `
      :host {
        @apply inline-block flex-shrink-0;
        fill: currentColor;
        height: 1em;
        width: 1em;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SvgIconComponent {
  @Input()
  set key(name: string) {
    const icon = this.registry.get(name) ?? this.registry.get(this.config.missingIconFallback?.name);

    if (icon) {
      this.element.setAttribute('aria-label', `${name}-icon`);
      this.element.classList.remove(`svg-icon-${this.lastKey}`);
      this.lastKey = name;
      this.element.classList.add(`svg-icon-${name}`);
      this.element.innerHTML = icon;
    }
  }

  @Input()
  set class(value: string) {
    this.element.classList.add(...value.split(' '));
  }

  @Input() set width(value: number | string) {
    this.element.style.width = coerceCssPixelValue(value);
  }

  @Input() set height(value: number | string) {
    this.element.style.height = coerceCssPixelValue(value);
  }

  @Input()
  set fontSize(value: number | string) {
    this.element.style.fontSize = coerceCssPixelValue(value);
  }

  private lastKey!: string;

  constructor(
    private host: ElementRef,
    private registry: SvgIconRegistry,
    @Inject(SVG_ICONS_CONFIG) private config: SVG_CONFIG
  ) {}

  get element() {
    return this.host.nativeElement;
  }
}

function coerceCssPixelValue(value: unknown): string {
  if (value == null) {
    return '';
  }

  return typeof value === 'string' ? value : `${value}px`;
}
